// extracted by mini-css-extract-plugin
module.exports = {"container":"Scores_container__3WLgy"};